import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import FaqParagraph from './faq_paragraph';

const FaqSection = forwardRef(({ title, content }, ref) => (
  <div className="site-faq-section-wrapper">
    <section className="site-faq-section" ref={ref}>
      <header className="site-faq-section__header">
        <div className="site-faq-section__title">
          <h2 className="bvs-h4">{title}</h2>
        </div>
      </header>
      <div>
        {content.map(({ name, acceptedAnswer: { text } }) => (
          <FaqParagraph
            key={name}
            title={name}
            content={text}
          />
        ))}
      </div>
    </section>
  </div>
));

FaqSection.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.instanceOf(Array).isRequired,
};

export default FaqSection;
